import Chip from '@mui/material/Chip'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { Button, Col, Grid, Input, Row, Span } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { COLORS, SPACING, TYPOGRAPHY } from 'utils'

const prioridades = [
  '1ª Mobilização',
  'Última Mobilização',
  'Denúncia',
  'Projeto',
  'Alerta',
  'Últ. Análise',
  'Valor Folha',
  'Qtd. Efetivos'
]

interface GenerateCreProps {
  qtdCarteiraItens: string
  pesquisaGeral: string
  ordemPrioridades: string[]
  handleChangeQtdCarteira: any
  handleChangePesqisaGeral: any
  handleChangeOrdemPrioridades: any
  handleSearchCre: () => void
  handlePesquisaGeral: () => void
  handleClearButton: () => void
  existingWallet: string
}

const GenerateCreForm: React.FC<GenerateCreProps> = ({
  qtdCarteiraItens,
  pesquisaGeral,
  ordemPrioridades,
  handleChangeQtdCarteira,
  handleChangePesqisaGeral,
  handleChangeOrdemPrioridades,
  handleSearchCre,
  handlePesquisaGeral,
  handleClearButton,
  existingWallet
}) => {
  return (
    <>
      <Grid
        gridCols="6.5fr 1.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing15} 0 ${SPACING.spacing15} 0`}
      >
        <Col>
          <Span text="Ordem de Prioridade" />
          <Select
            labelId="multiple-chip-label"
            id="multiple-chip"
            multiple
            value={ordemPrioridades}
            onChange={handleChangeOrdemPrioridades}
            variant="standard"
            disabled={existingWallet === 'checklist' ? true : false}
            renderValue={(ordemPrioridades) => (
              <Row gap="5px">
                {ordemPrioridades.map((value) => (
                  <Chip key={value} label={value} />
                ))}
              </Row>
            )}
          >
            {prioridades.map((prioridade) => (
              <MenuItem key={prioridade} value={prioridade}>
                {prioridade}
              </MenuItem>
            ))}
          </Select>
        </Col>
        {existingWallet === 'checklist' ? (
          <Col>
            <Span
              text="Carteira já gerada"
              fontSize={TYPOGRAPHY.subtitleSize20}
              color={COLORS.alert}
            />
            <Span
              text="nesta competência"
              fontSize={TYPOGRAPHY.subtitleSize20}
              color={COLORS.alert}
            />
          </Col>
        ) : null}
      </Grid>
      <Grid
        gridCols="1fr 3fr 2fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing15} 0`}
      >
        <Input
          label="Quantidade"
          placeholder="Nº"
          value={qtdCarteiraItens}
          onChange={handleChangeQtdCarteira}
          disabled={existingWallet === 'checklist' ? true : false}
          maxLength={3}
        />
      </Grid>
      <Row
        alignItems="center"
        justifyContent="flex-end"
        marginTop={SPACING.spacing15}
      >
        <Button
          text="Limpar"
          onClick={handleClearButton}
          variantButton="text"
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Button
          // endIcon={<MagnifyingGlassIcon />}
          text="Simular"
          onClick={handleSearchCre}
          marginLeft={SPACING.spacing15}
        />
      </Row>
      <Row justifyContent={'flex-end'}>
        <Input
          label="Pesquisa Geral"
          placeholder="Pesquisar"
          value={pesquisaGeral}
          onChange={handleChangePesqisaGeral}
          // disabled={existingWallet === 'checklist' ? true : false}
          width={`${SPACING.spacing300}`}
          inputIcon={<MagnifyingGlassIcon onClick={handlePesquisaGeral} />}
        />
      </Row>
    </>
  )
}

export default GenerateCreForm
